<template>
  <div class="jump_page" v-loading="loading">
    
  </div>
</template>
<script>
  import { loginByTicket } from '@/api/login'

  export default {
    data () {
      return {
        loading: true
      }
    },
    methods: {
      async autoLogin (ticket) {
        const { code, result } = await loginByTicket({ ticket })
        if (code !== 200) return
        const { token, ...userInfo } = result
        await this.$store.dispatch('user/setTokenAndUserInfo', { token, auto: false, userInfo })
        await this.$store.dispatch('user/setOrigin', true)
        this.$router.push({ path: '/' })
      }
    },
    created() {
      const ticket = this.$route.query?.ticket
      this.autoLogin(ticket)
    },
  }
</script>
<style lang="less" scoped>
  .jump_page {
    width: 100%;
    height: 100%;
  }
</style>
